// Exported from EmitterTool
export default {
  "name": "Rain",
  "version": 1,
  "createdAt": "2025-12-04T00:33:29.749Z",
  "meta": {
    "emitterShape": "random",
    "shapeSettings": {
      "radius": 1,
      "width": 2,
      "height": 2,
      "rotationDeg": 0,
      "angleDeg": 0,
      "spreadDeg": 30,
      "minDist": 0,
      "maxDist": 3,
      "pulseEnabled": false,
      "spawnFromOrigin": false,
      "spawnMode": "shape",
      "feederCount": 3,
      "feederRadiusM": 0.3,
      "feederJitterPct": 25,
      "beamEnabled": true,
      "beamBaseWidthPx": 24,
      "beamMaxLengthPx": 600,
      "beamCoreColor": "#ffffff",
      "beamGlowColor": "#66ccff",
      "beamCoreAlpha": 1,
      "beamGlowAlpha": 0.5,
      "beamHardCap": false,
      "beamCollideWithWalls": true,
      "beamPulseSpeed": 0.8,
      "beamNoise": 0.2,
      "beamNoiseSpeed": 1,
      "beamTileW": 128,
      "beamAngleDeg": 0,
      "startDeg": 0,
      "endDeg": 90,
      "arcSweepDeg": 90,
      "arcRotationDeg": 0,
      "rotationAnimEnabled": false,
      "rotationAnimDir": "ccw",
      "rotationAnimSpeedDegS": 45,
      "rotationAffectsParticles": true,
      "overlayCling": false
    },
    "effectSettings": {
      "fogHidden": true,
      "fogAlpha": 1,
      "orbitMode": "aroundOrigin",
      "rotateEnabled": false,
      "rotateDirection": "ccw",
      "rotateSpeedAbsDps": 90,
      "rotateSpeedDegPerS": 90,
      "spriteMode": "single",
      "selectedSprite": "fx-stone05",
      "selectedSprites": [
        "fx-stone05"
      ],
      "selectedAnimFrames": [],
      "spriteAnimatedEnabled": false,
      "pps": 412,
      "maxAlive": 1000,
      "speedMin": 1,
      "speedMax": 3,
      "lifespanMode": "time",
      "lifeMinS": 1,
      "lifeMaxS": 2.5,
      "rangeMeters": 10,
      "targetKillDistMeters": 0.25,
      "alphaStart": 1,
      "alphaEnd": 0,
      "scaleStart": 0.1,
      "scaleEnd": 1,
      "blendMode": "NORMAL",
      "tintEnabled": false,
      "tintStart": "#ffffff",
      "tintEnd": "#ffffff",
      "tintEase": "linear",
      "facingMode": "deg_from_origin",
      "facingDegFromOrigin": 0,
      "orbitEnabled": false,
      "orbitDirection": "ccw",
      "orbitSpeedAbsDps": 90,
      "orbitSpeedDegPerS": 90,
      "orbitLockRadii": true,
      "orbitRadiusMinM": 1,
      "orbitRadiusMaxM": 1,
      "orbitShape": "circle",
      "orbitEllipseRxM": 1,
      "orbitEllipseRyM": 1,
      "orbitEllipseTiltDeg": 0,
      "orbitStartPhaseMode": "random",
      "orbitStartPhaseJitterDeg": 30,
      "orbitApplyMode": "all",
      "orbitApplyPercent": 100,
      "orbitGroupTransform": false,
      "gravityEnabled": true,
      "gravitySpeed": -7.3,
      "gravityLingerS": 0.1,
      "glowEnabled": false,
      "glowPercent": 100,
      "glowIntensity": 1,
      "glowReachM": 10,
      "glowReachPx": 0,
      "glowDurationS": 0.75,
      "useWalls": false,
      "wallResponse": "none",
      "useTokenCollision": false,
      "tokenResponse": "none",
      "collisionEffectEnabled": false,
      "collisionScale": 1,
      "collisionAlpha": 1,
      "collisionLifespanMs": 400,
      "collisionFxRotationMode": "none",
      "trailEnabled": false
    },
    "selectedSprite": "fire_flame1",
    "showShape": true
  },
  "parent": {
    "emitterShape": "point",
    "shapeSettings": {},
    "effectSettings": {},
    "spriteMode": "single",
    "selectedSprite": null,
    "selectedSprites": [],
    "selectedAnimFrames": [],
    "spriteAnimatedEnabled": false,
    "animFps": 12
  },
  "layers": [],
  "sequence": [],
  "TargetingPanel": {
    "presetId": "global",
    "mode": "global",
    "rangeM": 51.5,
    "headSpeedMps": 40
  },
  "TrailsPanel": {
    "trailEnabled": false,
    "trailExternalSampling": true,
    "trailMinDistM": 0,
    "trailMaxDistM": 6,
    "trailMinSampleM": 0.15,
    "trailSmooth": true,
    "trailZ": 409
  },
  "TimingPanel": {
    "fireMode": "rule",
    "ruleStyle": "infinite",
    "timedDur": 3
  },
  "subEmitters": {
    "enabled": false,
    "parentIndex": 0,
    "count": 0
  },
  "sequencer": {
    "enabled": false,
    "steps": []
  },
  "spell": {
    "trigger": {
      "type": "AutoGlobalAmbient"
    },
    "targeting": {
      "mode": "Global"
    }
  }
};
